import { createContext, useContext } from 'react';

const LayoutContext = createContext(false);

export const useIsInsideLayout = () => useContext(LayoutContext);

export default LayoutContext;
